import { WalletConnectPay as Client } from "./client.js";

export * from "./constants/index.js";
export * from "./types/index.js";
export * from "./providers/index.js";

export const WalletConnectPay = Client;
export default Client;
